import React from 'react'
import {Avatar, Card} from '@therms/atalaya'
import {formatAddress, getInitials} from '@therms/web-js'
import {
  getTHERMSImageThumbnailUrl,
  IdLabel,
  LocationGroupTags,
  RPCDocs,
} from '@therms/react-modules'

interface LocationCardProps {
  active: boolean
  address?: RPCDocs.Locations.GetLocationsList.v1.Address
  idLabel?: string
  locationGroupIds?: string[]
  name: string
  onClick?: () => void
  primaryImageUrl?: string
}

function LocationCard({
  active,
  address,
  idLabel,
  locationGroupIds,
  name,
  onClick,
  primaryImageUrl,
}: LocationCardProps) {
  return (
    <Card className="cursor-pointer" onClick={onClick} space="xxs" padding="sm">
      <div className="gap-x-base gap-y-sm flex flex-wrap items-start justify-between">
        <div className="flex items-center">
          <div className="mr-sm">
            <Avatar
              url={getTHERMSImageThumbnailUrl(primaryImageUrl)}
              symbol={getInitials(name)}
              size="xl"
            />
          </div>

          <div className="flex flex-col">
            {!active && (
              <span className="text-small text-color-critical">Inactive</span>
            )}

            <IdLabel
              className="text-color-subtle text-sm font-bold"
              idLabel={idLabel}
            />
            <div className="text-color-strong">{name}</div>
            <div className="whitespace-pre-wrap font-light">
              {formatAddress(address, true) || ' '}
            </div>
          </div>
        </div>

        {Array.isArray(locationGroupIds) && !!locationGroupIds.length && (
          <LocationGroupTags locationGroupIds={locationGroupIds} max={3} />
        )}
      </div>
    </Card>
  )
}

export {LocationCard}
